/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useQuery, useLazyQuery } from '@apollo/client';
import { useSelector, connect, useDispatch } from 'react-redux';
import * as Q from '../../constants/graphqlQueries';
import TeamDates from './TeamDates/TeamDates';
import Teams from './Teams/Teams';
import {
  setSelectedTeamName, setSelectedDateRangePicker, setAlertCounts, setSelectedAlertType,
} from '../../store/actions/Alerts/action';
import UserRoles from '../../constants/userRoles';
import CurrentContext from '../../context/current-context';

import './Landing.css';
import SwitchCustom from '../Switch/SwitchCustom';
import AlertType from '../../constants/alertType';

const getSupervisorInfoFromUser = (user) => ({
  SupervisorEmployeeId: user.UserId,
  SupervisorEmployeeData: `${user.LastName}, ${user.FirstName}`,
});
const switchOptions = {
  leftTitle: 'Schedule',
  rightTitle: 'Performance',
};
const pollingFrequency = 4 * 60 * 1000;

const Landing = ({
  setSelectedTeamName,
  setAlertCounts,
  setSelectedDateRangePicker,
}) => {
  const navigate = useNavigate();
  const selectedTeamName = useSelector((state) => state.Alerts.selectedTeamName);
  const selectedAlertType = useSelector((state) => state.Alerts.selectedAlert);
  const user = useSelector((state) => state.User);
  const selectedDateRangePicker = useSelector((state) => state.Alerts.selectedDateRangePicker);
  const dispatch = useDispatch();

  const [supervisors, setSupervisors] = useState([]);
  const [supervisorSelected, setSupervisorSelected] = useState();

  const { data: dataSupervisors } = useQuery(Q.SUPERVISORS_GA_QUERY);

  const [getScheduleAlerts, {
    data: scheduleAlertsCount, 
    loading: loadingScheduleAlerts,
    startPolling: startPollingScheduleAlerts,
    stopPolling: stopScheduleAlerts
  }] = useLazyQuery(Q.COUNT_SCHEDULE_ALERT);

  const [getPerformanceAlerts, 
    { 
      data: performanceAlertsCount, 
      loading: loadingPerformanceAlerts, 
      startPolling: startPollingPerformanceAlerts, 
      stopPolling: stopPerformanceAlerts 
    }] = useLazyQuery(Q.COUNT_PERFORMANCE_ALERT);

  useEffect(() => {
    if (dataSupervisors) {
      const indexSupervisor = dataSupervisors.supervisors.findIndex(
        (e) => parseInt(e.SupervisorEmployeeId, 10) === user.UserId,
      );
      if (indexSupervisor < 0) {
        setSupervisors([getSupervisorInfoFromUser(user), ...dataSupervisors.supervisors]);
      } else {
        setSupervisors(dataSupervisors.supervisors);
      }
    }
  }, [dataSupervisors]);

  useEffect(() => {
    if (supervisors && supervisors.length > 0 && !supervisorSelected) {
      setSupervisorSelected(
        supervisors.find((s) => parseInt(s.SupervisorEmployeeId, 10) === user.EmployeeId),
      );
    }
  }, [supervisors]);

  useEffect(() => {
    if (scheduleAlertsCount) {
      setAlertCounts({
        ...scheduleAlertsCount.countScheduleAlerts,
      });
    }
  }, [scheduleAlertsCount]);

  useEffect(() => {
    if (performanceAlertsCount) {
      setAlertCounts({
        ...performanceAlertsCount.countPerformanceAlerts,
      });
    }
  }, [performanceAlertsCount]);

  useEffect(() => {
    if (selectedAlertType === AlertType.schedule) {
      if (scheduleAlertsCount) {
        setAlertCounts({
          ...scheduleAlertsCount.countScheduleAlerts,
        });
      }

      getScheduleAlerts({
        variables: {
          EmployeeId: parseInt(user.EmployeeId, 10),
          CustomInit: selectedDateRangePicker[0],
          CustomEnd: selectedDateRangePicker[1]
        }
      });
      startPollingScheduleAlerts(pollingFrequency);
    }

    if (selectedAlertType === AlertType.performance) {
      if (performanceAlertsCount) {
        setAlertCounts({
          ...performanceAlertsCount.countPerformanceAlerts,
        });
      }

      getPerformanceAlerts({
        variables: {
          EmployeeId: parseInt(user.EmployeeId, 10),
          CustomInit: selectedDateRangePicker[0],
          CustomEnd: selectedDateRangePicker[1]
        }
      });
      startPollingPerformanceAlerts(pollingFrequency);
    }
  }, [selectedAlertType, user]);

  const onChangeDates = async (rangeDates) => {
    stopPerformanceAlerts();
    stopScheduleAlerts();
    setSelectedDateRangePicker(rangeDates);
  }

  console.log('Landing.jsx: Current User Role:', user.Role);
  if (user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner && user.Role !== UserRoles.WFM && user.Role !== UserRoles['G&A']) {
    console.log('Landing.jsx: User does not have access.');
    return navigate(
      '/AccessDenied'
    );
  }

  const handleAlertTypes = checked => {
    if (checked) dispatch(setSelectedAlertType(AlertType.performance))
    else dispatch(setSelectedAlertType(AlertType.schedule))
  }

  return (
    <>
      <div className='__landing__row'>
        <span className='__landing__row__title'>Alert Type</span>
        <SwitchCustom
          options={switchOptions}
          handleSwitch={handleAlertTypes}
          switchStatus={selectedAlertType !== AlertType.schedule ?? true}
          isDualOption
        />
      </div>
      <Box className='Landing'>
        <div className='teams'>
        <CurrentContext.Provider value={loadingScheduleAlerts || loadingPerformanceAlerts}>
          <Teams
            onClickTeam={setSelectedTeamName}
            selectedTeamName={selectedTeamName}
          />
          </CurrentContext.Provider>
        </div>
        <div className='teams-dates-boxes'>
        <CurrentContext.Provider value={loadingScheduleAlerts || loadingPerformanceAlerts}>
          <TeamDates selectedTeamName={selectedTeamName} onChangeDates={onChangeDates} />
        </CurrentContext.Provider>
        </div>
      </Box>
    </>
  );
};
Landing.propTypes = {
  setSelectedTeamName: PropTypes.func.isRequired,
  setAlertCounts: PropTypes.func.isRequired,
  setSelectedDateRangePicker: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  setSelectedTeamName(payload) {
    dispatch(setSelectedTeamName(payload));
  },
  setAlertCounts(counts) {
    dispatch(setAlertCounts(counts));
  },
  setSelectedDateRangePicker(payload) {
    dispatch(setSelectedDateRangePicker(payload));
  }
});

export default connect(null, mapDispatchToProps)(Landing);
